/**
 * FormSubmission model translations
 *
 * Translation keys follow the pattern: models.form-submission.{category}.{key}
 */
export default {
    en: {
        singular: "Submitted Form",
        plural: "Submitted Forms",

        fields: {
            status: "Status",
            submitted_by: "Submitted by",
            submitted_by_user_id: "Submitted by",
            submitted_at: "Submitted at",
            raw_payload: "Raw payload",
            audit_data: "Audit data",
            created_at: "Created",
            // Filter-chip labels (trField lookup on filter key)
            form_id: "Form",
            form_kind: "Form type",
            client_id: "Client",
            // Dot-notation column/field keys — must be nested so vue-i18n's
            // deep lookup resolves `fields.form.title`, `fields.submittedBy.display_name`, etc.
            form: {
                title: "Form",
                kind: "Type",
            },
            submittedBy: {
                display_name: "Submitted by",
            },
            assignment: {
                client: {
                    name: "Client",
                },
            },
            normalized_summary: {
                score: "Score",
                passed: "Passed",
                issues: "Issues",
                answered_fields: "Answered fields",
                total_fields: "Total fields",
            },
        },

        tabs: {
            summary: "Summary",
            answers: "Answers",
            audit: "Audit",
        },

        options: {
            status: {
                draft: "Draft",
                submitted: "Submitted",
                void: "Void",
            },
            form_kind: {
                task: "Task",
                survey: "Survey",
                legal: "Legal",
                inspection: "Inspection",
                checklist: "Checklist",
            },
        },

        badges: {
            draft: "Draft",
            submitted: "Submitted",
            void: "Void",
            task: "Task",
            survey: "Survey",
            legal: "Legal",
            inspection: "Inspection",
            checklist: "Checklist",
        },

        actions: {
            view: "View",
            void: "Void",
        },

        filters: {
            status: "Status",
            form_id: "Form",
            form_kind: "Form type",
            client_id: "Client",
            submitted_at: "Submission date",
            submitted_by_user_id: "Submitted by",
        },
    },

    fr: {
        singular: "Formulaire Soumis",
        plural: "Formulaires Soumis",

        fields: {
            status: "Statut",
            submitted_by: "Soumis par",
            submitted_by_user_id: "Soumis par",
            submitted_at: "Soumis le",
            raw_payload: "Donnees brutes",
            audit_data: "Donnees d'audit",
            created_at: "Cree le",
            // Filter-chip labels
            form_id: "Formulaire",
            form_kind: "Type de formulaire",
            client_id: "Client",
            // Dot-notation column/field keys — nested for vue-i18n deep lookup.
            form: {
                title: "Formulaire",
                kind: "Type",
            },
            submittedBy: {
                display_name: "Soumis par",
            },
            assignment: {
                client: {
                    name: "Client",
                },
            },
            normalized_summary: {
                score: "Score",
                passed: "Reussi",
                issues: "Problemes",
                answered_fields: "Champs remplis",
                total_fields: "Champs totaux",
            },
        },

        tabs: {
            summary: "Resume",
            answers: "Reponses",
            audit: "Audit",
        },

        options: {
            status: {
                draft: "Brouillon",
                submitted: "Soumis",
                void: "Annulé",
            },
            form_kind: {
                task: "Tâche",
                survey: "Sondage",
                legal: "Légal",
                inspection: "Inspection",
                checklist: "Liste de vérification",
            },
        },

        badges: {
            draft: "Brouillon",
            submitted: "Soumis",
            void: "Annule",
            task: "Tache",
            survey: "Sondage",
            legal: "Legal",
            inspection: "Inspection",
            checklist: "Liste de verification",
        },

        actions: {
            view: "Voir",
            void: "Annuler",
        },

        filters: {
            status: "Statut",
            form_id: "Formulaire",
            form_kind: "Type de formulaire",
            client_id: "Client",
            submitted_at: "Date de soumission",
            submitted_by_user_id: "Soumis par",
        },
    },
};
